/**
 * RID 2.0 CEU Cap Utilities
 * Handles RID's rule that only 2.0 CEUs of General Studies count toward cycle requirements
 */

const GENERAL_STUDIES_CAP = 2.0;

/**
 * Calculate capped and overflow CEUs for General Studies
 * @param {number} actualCEUs - Actual General Studies CEUs earned
 * @returns {Object} { capped, overflow, actual }
 */
export function calculateGeneralStudiesCap(actualCEUs) {
  const capped = Math.min(actualCEUs, GENERAL_STUDIES_CAP);
  const overflow = Math.max(0, actualCEUs - GENERAL_STUDIES_CAP);
  
  return {
    capped: parseFloat(capped.toFixed(1)),
    overflow: parseFloat(overflow.toFixed(1)),
    actual: parseFloat(actualCEUs.toFixed(1))
  };
}

/**
 * Calculate total CEUs with RID cap applied
 * @param {Object} categories - { professionalStudies, generalStudies, ppo }
 * @returns {Object} { total, professionalStudies, generalStudies, ppo, generalStudiesOverflow }
 */
export function calculateCappedTotal(categories) {
  const { professionalStudies = 0, generalStudies = 0, ppo = 0 } = categories;
  
  const gsCap = calculateGeneralStudiesCap(generalStudies);
  
  return {
    total: parseFloat((professionalStudies + gsCap.capped + ppo).toFixed(1)),
    professionalStudies: parseFloat(professionalStudies.toFixed(1)),
    generalStudies: gsCap.capped,
    generalStudiesActual: gsCap.actual,
    generalStudiesOverflow: gsCap.overflow,
    ppo: parseFloat(ppo.toFixed(1))
  };
}

export default {
  GENERAL_STUDIES_CAP,
  calculateGeneralStudiesCap,
  calculateCappedTotal
};
